module.exports = __webpack_public_path__ + "img/logo.3f20856e.svg";